/* eslint-disable */
import _m0 from "protobufjs/minimal";
import {
  ObstacleAvoidanceEnum_Enum,
  obstacleAvoidanceEnum_EnumFromJSON,
  obstacleAvoidanceEnum_EnumToJSON,
} from "../../obstacle_avoidance";
import { FreeLookMode_Enum, freeLookMode_EnumFromJSON, freeLookMode_EnumToJSON } from "../../waypoints";

export const protobufPackage = "skills";

/** Arguments for setting obstacle avoidance. */
export interface SetObstacleAvoidanceActionArgs {
  /** Obstacle avoidance setting. */
  oaSetting: ObstacleAvoidanceEnum_Enum;
  /** Allow free look to persist during the set OA action. */
  freeLookMode: FreeLookMode_Enum;
}

export interface SetObstacleAvoidanceResultData {
}

export interface SetObstacleAvoidanceActionStateData {
}

function createBaseSetObstacleAvoidanceActionArgs(): SetObstacleAvoidanceActionArgs {
  return { oaSetting: 0, freeLookMode: 0 };
}

export const SetObstacleAvoidanceActionArgs = {
  encode(message: SetObstacleAvoidanceActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.oaSetting !== 0) {
      writer.uint32(8).int32(message.oaSetting);
    }
    if (message.freeLookMode !== 0) {
      writer.uint32(16).int32(message.freeLookMode);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SetObstacleAvoidanceActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetObstacleAvoidanceActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.oaSetting = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.freeLookMode = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetObstacleAvoidanceActionArgs {
    return {
      oaSetting: isSet(object.oaSetting) ? obstacleAvoidanceEnum_EnumFromJSON(object.oaSetting) : 0,
      freeLookMode: isSet(object.freeLookMode) ? freeLookMode_EnumFromJSON(object.freeLookMode) : 0,
    };
  },

  toJSON(message: SetObstacleAvoidanceActionArgs): unknown {
    const obj: any = {};
    if (message.oaSetting !== 0) {
      obj.oaSetting = obstacleAvoidanceEnum_EnumToJSON(message.oaSetting);
    }
    if (message.freeLookMode !== 0) {
      obj.freeLookMode = freeLookMode_EnumToJSON(message.freeLookMode);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetObstacleAvoidanceActionArgs>, I>>(base?: I): SetObstacleAvoidanceActionArgs {
    return SetObstacleAvoidanceActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetObstacleAvoidanceActionArgs>, I>>(
    object: I,
  ): SetObstacleAvoidanceActionArgs {
    const message = createBaseSetObstacleAvoidanceActionArgs();
    message.oaSetting = object.oaSetting ?? 0;
    message.freeLookMode = object.freeLookMode ?? 0;
    return message;
  },
};

function createBaseSetObstacleAvoidanceResultData(): SetObstacleAvoidanceResultData {
  return {};
}

export const SetObstacleAvoidanceResultData = {
  encode(_: SetObstacleAvoidanceResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SetObstacleAvoidanceResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetObstacleAvoidanceResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SetObstacleAvoidanceResultData {
    return {};
  },

  toJSON(_: SetObstacleAvoidanceResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SetObstacleAvoidanceResultData>, I>>(base?: I): SetObstacleAvoidanceResultData {
    return SetObstacleAvoidanceResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetObstacleAvoidanceResultData>, I>>(_: I): SetObstacleAvoidanceResultData {
    const message = createBaseSetObstacleAvoidanceResultData();
    return message;
  },
};

function createBaseSetObstacleAvoidanceActionStateData(): SetObstacleAvoidanceActionStateData {
  return {};
}

export const SetObstacleAvoidanceActionStateData = {
  encode(_: SetObstacleAvoidanceActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SetObstacleAvoidanceActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetObstacleAvoidanceActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SetObstacleAvoidanceActionStateData {
    return {};
  },

  toJSON(_: SetObstacleAvoidanceActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SetObstacleAvoidanceActionStateData>, I>>(
    base?: I,
  ): SetObstacleAvoidanceActionStateData {
    return SetObstacleAvoidanceActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetObstacleAvoidanceActionStateData>, I>>(
    _: I,
  ): SetObstacleAvoidanceActionStateData {
    const message = createBaseSetObstacleAvoidanceActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
